// Imports => Vendor
import axios from 'axios';

// Imports => MOBX
import {
  makeObservable,
  observable,
  computed,
  action,
  runInAction,
} from 'mobx';

// Imports => Constants
import { KEYS } from '@opp/ui-kit';

// Imports => Models
import { TransactionModel } from '@models/transaction.model';

// Imports => Utilities
import {
  AcSaveState,
  AcRemoveState,
  AcIsSet,
  AcIsNull,
  AcFormatErrorMessage,
  AcIsUndefined,
  AcFormatRequestParameters,
} from '@opp/ui-kit';
import { AcAutoSave } from '@utils';

const _default = {
  options: {},
  meta: null,
  withdrawal: null,
};

let app = {};

export class WithdrawalsStore {
  constructor(store) {
    makeObservable(this);

    AcAutoSave(this);

    app.store = store;
  }

    @observable
      withdrawal = _default.withdrawal;

    @computed
    get current_withdrawal() {
      return this.withdrawal || [];
    }

    @observable
      loading = {
        status: false,
        message: null,
      };

    @computed
    get is_loading() {
      return this.loading.status;
    }

    @action
      setLoading = (state, message) => {
        this.loading = {
          status: state || false,
          message,
        };
      };

    @observable
      busy = {
        status: false,
        message: null,
      };

    @computed
    get is_busy() {
      return this.busy.status;
    }

    @action
      setBusy = (state, message) => {
        this.busy = {
          status: state || false,
          message,
        };
      };

    @action
      get_by_id = (t, id, options) => {
        this.setLoading(true);

        const params = AcFormatRequestParameters(this, options, true);

        return app.store.api.withdrawals
          .get_by_id(id, params)
          .then(async (response) => {
            const formatted = new TransactionModel(response);
            await this.set(KEYS.WITHDRAWAL, formatted);

            this.setLoading(false);

            return formatted;
          })
          .catch((error) => {
            if (!axios.isCancel(error))
              app.store.toasters.add({
                variant: 'error',
                title: `${t('withdrawals.failed-to-retrieve-with-id', {ns: 'store'})} '<strong>${id}</strong>'`,
                description: AcFormatErrorMessage(error),
              });

            this.setLoading(false);

            if (!axios.isCancel(error)) throw error;
          });
      };

    @action
      set = (target, value, save = false) => {
        if (!AcIsSet(target)) return;
        if (AcIsUndefined(this[target])) return;
        if (AcIsUndefined(value)) return;

        return new Promise((resolve) => {
          this[target] = value;
          if (save) AcSaveState(target, value);
          resolve();
        });
      };

    @action
      setState = (target, property, value, save = false) => {
        if (!AcIsSet(target)) return;
        if (AcIsUndefined(this[target])) return;
        if (!AcIsSet(property)) return;
        if (AcIsUndefined(value)) return;

        this[target][property] = value;
        if (save) AcSaveState(target, value);
      };

    @action
      reset = (target, save = false) => {
        if (!AcIsSet(target)) return;
        if (AcIsUndefined(this[target])) return;

        return new Promise((resolve) => {
          this[target] = _default[target];
          if (save && AcIsNull(_default[target])) {
            AcRemoveState(target);
          } else if (save) {
            AcSaveState(target, _default[target]);
          }

          resolve();
        });
      };
}

export default WithdrawalsStore;
